// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductsGrid_container__3h8tS","hasSelectedCards":"ProductsGrid_hasSelectedCards__Ckg58","gridItem":"ProductsGrid_gridItem__2pw-y","card":"ProductsGrid_card__3JUwG"};